import React, { useState } from "react";
import { Link as RouterLink } from "react-router";
import { useTranslation } from "react-i18next";
import { MenuItem, Typography } from "@mui/material";
import { BookingTypeEnum } from "@rentablo/api/apiv1";
import { ButtonWithActionMenu } from "@rentablo/components";
import { BookingsTableDeleteAction } from "./BookingsTableDeleteAction";

export interface Props {
  bookingId: number;
  investmentId: number;
  bookingType: BookingTypeEnum;
}

export const BookingsTableMoreAction = ({
  bookingId,
  investmentId,
  bookingType,
}: Props) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <>
      <ButtonWithActionMenu testId="more-action-button">
        <>
          {bookingType !== "split" && bookingType !== "reverse_split" && (
            <MenuItem
              component={RouterLink}
              to={
                bookingType === "dividend" || bookingType === "purchase_right"
                  ? `/investments/${investmentId}/dividend-wizard/edit/${bookingId}`
                  : `/edit-transaction-wizard/${bookingId}`
              }
              data-testid="edit-action-item"
            >
              <Typography variant="inherit">
                {t("investment.protocolTable.actions.edit")}
              </Typography>
            </MenuItem>
          )}
          <MenuItem onClick={handleOpenDialog} data-testid="delete-action-item">
            <Typography variant="inherit">
              {t("investment.protocolTable.actions.delete")}
            </Typography>
          </MenuItem>
        </>
      </ButtonWithActionMenu>
      <BookingsTableDeleteAction
        dialogOpen={dialogOpen}
        bookingId={bookingId}
        onClose={handleCloseDialog}
      />
    </>
  );
};
